import React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faExclamation,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import '../assets/styles/alertmessage.css'

const messageColors = {
  Error: "red",
  Success: "#40f467",
  Info: "#1e90ff",
},
  icons = {
    Error: faTimes,
    Success: faCheck,
    Info: faExclamation,
  };

export const AlertMessageBox = ({ showAlertBox, setShowAlertBox, alertMessage }) => {
  let messageColor = alertMessage?.Errortype && alertMessage?.Errortype!='' ? messageColors[alertMessage.Errortype] : messageColors.Info;

  return (
    <div>
      <div
        id='toast'
        style={{ borderColor: messageColor }}
        className={`${showAlertBox ? "show" : ""}`}
      >
        <div className='messageheadContainer'>
          <div className='message-text text-1'>{(alertMessage?.title && alertMessage.title!='') ? alertMessage.title : ''}</div>
          <button
            className='toastCloser'
            onClick={() => setShowAlertBox(false)}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className='message'>
          <span className='message-text text-2'>{(alertMessage?.message && alertMessage.message!='') ? alertMessage.message : ''}</span>
        </div>
      </div>
    </div>
  );
};





let showAlertFunction;

const AlertPopup = () => {
  const [alert, setAlert] = useState(null);

  const showAlert = (status, message) => {
    setAlert({ status, message });
    setTimeout(() => setAlert(null), 2000);
  };

  showAlertFunction = showAlert;

  const closeAlert = () => setAlert(null);

  return (
    alert && (
      <div className={`alert-popup alert-${alert.status.toLowerCase()}`}>
        <span>{alert.message}</span>
        <button className="close-btn" onClick={closeAlert}>
          &times;
        </button>
      </div>
    )
  );
};

// Export the showAlert function
export const triggerAlert = (status, message) => {
  if (showAlertFunction) {
    showAlertFunction(status, message);
  }
};

export default AlertPopup;
